// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"220":"159d1258","447":"a308ee49","672":"f546f675"}[chunkId] + ".js";
};